import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import ElementLocale from 'element-ui/lib/locale';
import ElementUI from 'element-ui'

function loadLocaleMessages () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1];
      let EleLocaleMsg = locale == 'en' ? enLocale : zhLocale;
      messages[locale] = locales(key)
      messages[locale] = {
        ...messages[locale],
        ...EleLocaleMsg
      }
    }

  })
  return messages
}


var name="lang";
var  reg = new  RegExp( "(^|&)" + name + "=([^&]*)(&|$)" );
var  r = window.location.search.substr(1).match(reg);
var lang=r!=null?unescape(r[2]):"";
//console.log(lang,"===lang===lang===")
if(lang){
  localStorage.setItem('locale',lang);
}
var  navLang = navigator.language;
//navLang="ja-cn";
if(navLang=="zh-tw"){
  var default_lang="zh-tw";
}else{
  var navLang_arr=navLang.split("-");
  var nlang=navLang_arr[0];
  var lang_arr={"zh":"zh","ar":"ar-ab","de":"de-de","en":"en","es":"es-la","fr":"fr-fr",
    "in":"in-do","it":"it-it","ja":"ja-jp","pt":"pt-pt","ru":"ru-ru"};
  var default_lang=lang_arr[nlang];
}

 //console.log(default_lang,"===default_lang====");
 //localStorage.removeItem('locale')
//console.log(localStorage.getItem('locale'),"==locale==");
if(!localStorage.getItem('locale')){
  localStorage.setItem('locale',default_lang);
}

// 在这里修改 默认语言和备选语言  默认是中文
const locale = localStorage.getItem('locale') || default_lang
const i18n = new VueI18n({
  locale: locale,
  //fallbackLocale: localStorage.getItem('locale') || 'en',
  fallbackLocale: locale,
  messages: loadLocaleMessages(),
  silentTranslationWarn: true
})

let Locale = locale=='zh'||locale=='zh-tw'||locale=='zh-cn' ? zhLocale : enLocale
// console.log('eleui', Locale);
Vue.use(ElementUI, { locale: Locale})
ElementLocale.i18n((key, value) => i18n.t(key, value));
export default i18n;